import { FC, useState } from 'react';

import { Fade, Typography } from '@mui/material';
import { Dashboard } from '@src/main/modules/common/dashboard/domain/Dashboard';

import DashboardCardResume from '@src/main/ui/components/common/Dashboard/DashboardCardResume/DashboardCardResume';
import ShowAllButton from '@src/main/ui/components/common/Dashboard/DashboardList/DashboardListDesktop/buttons/ShowAllButton';
import { useGetDashboardsToShowByMediaQuery } from '@src/main/ui/components/common/Dashboard/DashboardList/DashboardListDesktop/hooks/useGetDashboardsToShowByMediaQuery';
import { HighlighFields } from '@src/main/ui/components/common/Dashboard/common/fields/highlighter/HighlighFields';
import { getIconId } from '@src/main/ui/components/common/Icon/IconId';
import styles from './DashboardListDesktop.module.scss';

interface Props {
  title?: string;
  dashboards: Dashboard[];
  isExpandable: boolean;
  highlighFields?: HighlighFields[];
  actions: {
    edit?: boolean;
    delete?: boolean;
    favorite?: boolean;
    info?: boolean;
  };
  onClickEdit: (dashboard: Dashboard) => void;
  onClickDelete: (dashboard: Dashboard) => void;
  onClickShowMoreInfo: (dashboard: Dashboard) => void;
  onClickFavorites: (dashboard: Dashboard) => void;
}
const defaultProps = { title: undefined, highlighFields: undefined };

const DashboardListDesktop: FC<Props> = ({
  dashboards,
  title,
  isExpandable,
  highlighFields,
  actions,
  onClickShowMoreInfo,
  onClickFavorites,
  onClickEdit,
  onClickDelete,
}) => {
  const [expanded, setExpanded] = useState(false);
  const { dashboardsToShow, isShowAllVisible, isCollapseVisible } =
    useGetDashboardsToShowByMediaQuery(dashboards, expanded, isExpandable);
  return (
    <div>
      {title && (
        <div className={styles.title}>
          {title !== 'Common' && <Typography variant="h5">{title}</Typography>}
          {isExpandable && (
            <ShowAllButton
              isCollapseVisible={isCollapseVisible}
              isShowAllVisible={isShowAllVisible}
              toggleExpanded={() => setExpanded((prevState) => !prevState)}
            />
          )}
        </div>
      )}
      <div className={styles.dashboardListDesktop}>
        {dashboardsToShow.map((dashboard) => (
          <div key={dashboard.id} className={styles.dashboardListDesktop__card}>
            <Fade in timeout={500}>
              <div>
                <DashboardCardResume
                  {...dashboard}
                  icon={getIconId(dashboard.area.name)}
                  areas={[
                    dashboard.area.name,
                    dashboard.area.subareaName,
                    dashboard.area.subsubareaName,
                  ]}
                  highlighFields={highlighFields}
                  actions={actions}
                  onClickEdit={() => onClickEdit(dashboard)}
                  onClickDelete={() => onClickDelete(dashboard)}
                  onClickFavorites={() => onClickFavorites(dashboard)}
                  onClickShowMoreInfo={() => onClickShowMoreInfo(dashboard)}
                  workspaceId={dashboard.workspaceId}
                  repositoryType={dashboard.repositoryType}
                />
              </div>
            </Fade>
          </div>
        ))}
      </div>
    </div>
  );
};

DashboardListDesktop.defaultProps = defaultProps;

export default DashboardListDesktop;
